import type {
  NotificationsReferential,
  NotificationsType,
} from "./referential-notifications.type";

export const filterNotificationByType = (
  notifications: NotificationsReferential[],
  type: NotificationsType
) => {
  return notifications.filter((notification) => notification.type === type);
};
